import { graphql } from "gql.tada";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { FootnoteFragment } from "@queries/fragments/FootnoteFragment";
import { LinkFragment } from "./fragments/LinkFragment";
import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";
import { EventChapterFragment } from "@queries/fragments/EventChapterFragment";

export const GetEventPageBySlug = graphql(
  `
    query GetEventPageBySlug(
      $slug: String
      $locale: String
      $preview: Boolean
    ) {
      eventsEventPageCollection(
        where: { slug: $slug }
        limit: 1
        locale: $locale
        preview: $preview
      ) {
        items {
          __typename
          sys { id }
          showPageInLocales
          slug
          theme { ...ThemeFragment }
          metadata { ...MetadataFragment }
          # localizationMarkets
          hero {
            sys { id }
            variant
            title
            subtitle
            description
            ctaText
            ctaLink
            backgroundImage { url contentType width height }
            overlayImage { url }
            previewVideo { url contentType }
            fullVideo { url contentType }
            fullWidthImage { url contentType }
            eyebrowImagesCollection {
              items { url contentType }
            }
            bodyRichText { ...RichEntryFragment }
          }
          eventDescription {
            sys { id }
            title
            descriptionRichText {
              json
              links {
                entries {
                  inline {
                    sys { id }
                    __typename
                    ... on Footnote { ...FootnoteFragment }
                  }
                }
              }
            }
          }
          eventDescriptionCta {
            ...LinkFragment
          }
          imageCarousel1Collection {
            items {
              ...AccessibleMediaFragment
            }
          }
          eventChaptersCollection {
            items {
              ...EventChapterFragment
            }
          }
          testimonial {
            sys { id }
            quotation
            attributionName
            attributionPosition
            attributionCompany
          }
          imageCarousel2Collection {
            items {
              ...AccessibleMediaFragment
            }
          }
          socialArcCarouselCollection(limit: 1) {
            items {
              title
              itemsCollection {
                items {
                  title
                  item {
                    ...AccessibleMediaFragment
                  }
                }
              }
            }
          }
          ctaFooter {
            sys { id }
            variant
            isVertical
            title
            titleRichText { json }
            cta { ...LinkFragment }
            backgroundImage { url title }
          }
        }
      }
    }
  `,
  [
    ThemeFragment,
    MetadataFragment,
    RichEntryFragment,
    FootnoteFragment,
    AccessibleMediaFragment,
    EventChapterFragment,
    LinkFragment,
  ]
);
